<template>
  <div class="">
    <div class="max-w-5xl mx-auto py-5 pb-0 px-2 ms:px-5">
      <div class="header relative">
        <router-link to="/" title="Pipefish logo">
          <svgicon class="pf-logo" name="pipefish-logo-on-light" width="90" height="90" />
        </router-link>
        <div class="header-links">
          <router-link to="/home" v-if="$route.name !== 'home'"> Home </router-link>
          <!-- <a @click="scrollTo('what-we-do')">What we do</a> -->
          <!-- <a @click="scrollTo('who-we-are')">Who we are</a> -->
          <!-- <a @click="navTo('/case-studies')">Case studies</a> -->
          <router-link :to="{ name: 'case-study-index' }"> Case studies </router-link>
          <router-link :to="{ name: 'our-people-index' }"> Our people </router-link>
          <router-link :to="{ name: 'products-index' }"> Products </router-link>

          <button
            type="button"
            class="button button--primary--outline p1os-mid-r r1ight-0"
            @click="Store.toggleContactUsModal()"
          >
            <strong>Contact us</strong>
          </button>
        </div>

        <nav class="header-links--collapse">
          <svgicon
            name="menu"
            color="#A1A1A1"
            width="24"
            height="24"
            title="Navigation"
            @click="openCollapse = true"
            v-if="!openCollapse"
          />
          <svgicon
            name="close"
            color="#A1A1A1"
            width="24"
            height="24"
            title="Close"
            @click="openCollapse = false"
            v-if="openCollapse"
          />
          <ul v-if="openCollapse">
            <li v-if="$route.name !== 'home'">
              <router-link to="/">Home</router-link>
            </li>
            <!-- <li @click="scrollTo('what-we-do')">What we do</li> -->
            <!-- <li @click="scrollTo('who-we-are')">Who we are</li> -->
            <li @click="navTo('/our-people')">Our people</li>
            <li @click="navTo('/case-studies')">Case studies</li>
            <li @click="navTo('/products')">Products</li>
            <li @click="Store.toggleContactUsModal()" class="color-orange">Contact us</li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import '@/components/svg/menu';
import '@/components/svg/close';
import '@/components/svg/pipefish-logo-on-light';
export default {
  name: 'SiteHeader',
  props: ['bg', 'collapse'],
  computed: {
    showBg: function() {
      return this.$props.bg === 'false' ? false : true;
    },
    doCollapse: {
      get: function() {
        return this.$props.collapse;
      }
    }
  },
  data: function() {
    return {
      openCollapse: false
    };
  },
  methods: {
    toggleCollapseMenu: function() {
      this.doCollapse = !this.doCollapse;
      // this.$props.collapse = !this.$props.collapse;
    },
    scrollTo: function(scrollTo) {
      // console.log(this.$router.currentRoute);
      if (this.$router.currentRoute.name.includes('home')) {
        let anchor = scrollTo.replace(/-/g, '');
        this.$SmoothScroll(document.getElementById(anchor), 800, null, null, 'y');
      } else {
        this.$router.push({ name: 'home-' + scrollTo });
      }
    },
    navTo: function(route, params) {
      if (this.$router.currentRoute.name.includes('/case-studies')) {
        this.$SmoothScroll(
          document.getElementsByClassName('sect-content')[0],
          800,
          null,
          null,
          'y'
        );
      } else {
        this.$router.push({ path: route, params: params });
      }
    }
  }
};
</script>

<style lang="scss">
$height_sm: 65px;
$height: 85px;
.header {
  z-index: 10;
  min-height: $height_sm;
  @include media('>=medium') {
    min-height: $height;
  }

  .pf-logo {
    // @include media('<medium') {
    width: 60px !important;
    height: 60px !important;
    // }
    @include media('>=medium') {
      width: 85px !important;
      height: 85px !important;
    }
  }

  .menu {
    background-color: transparent;
    border: none;

    svg path {
      fill: $Grey5Chicago;
    }

    @include media('>=medium') {
      display: none;
    }

    @include media('<medium') {
      display: inline-block;
      position: absolute;
      top: 26px;
      right: 0px;
    }
  }

  .header-links {
    a {
      font-size: 12px;
      color: $Grey5Chicago;
      display: inline-block;
      padding: 0;
      margin: 0;
      text-decoration: none;
      font-weight: 400;
      padding-bottom: 5px;
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 30px;
      }
      .svg-icon {
        position: relative;
        // top: 2px;
        path {
          fill: lighten($Grey5Chicago, 10%);
          // fill: red;
        }
      }
      &:hover {
        border-bottom: 2px solid darken($Grey5Chicago, 20%);
        color: darken($Grey5Chicago, 20%);
        // text-decoration: underline;
        // .svg-icon path {
        //   fill: darken($Grey5Chicago, 20%);
        //   fill: darken($LogoOrange1, 0%);
        // }
      }
      &.router-link-active {
        border-bottom: 2px solid $PriAstralBlue;
      }
    }
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    @include media('<medium') {
      display: none;
    }
    a {
      font-size: 14px;
    }
    &--collapse {
      display: none;
      // margin-bottom: -50px;
      @include media('<medium') {
        display: block;
      }
      svg {
        position: absolute;
        right: 0px;
        top: 10px;
        margin: 10px 10px;
      }
      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 0px 0;
        margin: 10px 0 0 0;
        li {
          display: inline-block;
          line-height: 1.5rem;
          margin-right: 10px;
          // text-transform: uppercase;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          color: $Grey5Chicago;
          width: auto;
          white-space: nowrap;
          &.color-orange {
            color: $LogoOrange1;
          }
          a {
            // text-transform: uppercase;
            text-decoration: none;
            color: $Grey5Chicago;
            padding: 0 0;
            &:hover {
              text-decoration: none;
            }
          }
        }
      }
    }
  }
}
</style>
